export const CCTV_VIEWER_URL = "https://yala-cctv.localth.ai";
